import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserApiResponse, UserViewModel } from '../interfaces/viewmodels/userviewmodel';

declare var RTA_API: string;
declare var ADESC_API: string;
declare var DBSService_BASE_URL: string;
declare var COMMON_API: string;
declare var FILEVAULT_URL: string;
declare var CURRENT_USER_ID: number;
declare var CURRENT_USER_LOGINID: string;
declare var CURRENT_USER_DISPLAYNAME: string;
declare var CURRENT_USER_EMAIL: string;
@Injectable({
  providedIn: 'root'
})

export class AccountService {
  
  public $CURRENT_USER_LOGINID: string = CURRENT_USER_LOGINID;
  public $CURRENT_USER_DISPLAYNAME: string = CURRENT_USER_DISPLAYNAME;

  RtaApi: string = RTA_API;
  AdescApi: string = ADESC_API;
  CommonApi: string = COMMON_API;
  FileVaultApi: string = FILEVAULT_URL;
  CurrentUserId: number = CURRENT_USER_ID;

  constructor(public http: HttpClient) { }
  
  
  createUser(user: UserViewModel): Observable<UserViewModel> {
    return this.http.post<UserViewModel>(this.CommonApi, user)
  }


  getUserDetails(id: string): Observable<UserViewModel> {
    return this.http.get<UserViewModel>(`${this.CommonApi}/User(${id})?$expand=SubApplicationLabels`)
  }


   getUserByEmail(id: string): Observable<UserViewModel> {
    return this.http.get<UserViewModel>(`${DBSService_BASE_URL}/api/Common/User(${CURRENT_USER_EMAIL})`)
  }


  updateUser(user: UserViewModel): Observable<UserViewModel> {
    return this.http.put<UserViewModel>(`${this.CommonApi}/User(${user.id})`, user)
  }

  deleteUser(id: number): Observable<void> {
    return this.http.delete<void>(`${this.CommonApi}/${id}`)
  }

  listUsers(): Observable<UserViewModel[]> {
    return this.http.get<UserViewModel[]>(`${this.CommonApi}/Users()`)
  }
}
